export const defaultLocation: H.geo.IPoint = {
  lat: 40.36554880796251,
  lng: -74.16726880556895,
}

export const defaultZoom = 14
